// Las jornadas al mes de una cuenta, con su excepción a la vista (#1809, Sebastián 28-oct):
// «~~3~~ → 4 jornadas al mes · acordado contigo». Una excepción es un acuerdo por cuenta
// (`Subscription.jornadas_pactadas`, piso sobre el plan): el back manda las que aplican (`jornadas`) y las
// del plan base (`jornadasPlan`, null = sin tope). Sin `jornadasPlan` (un back que no lo manda) o sin
// diferencia, se dice como siempre. 31 o más es «sin tope» (mismo número que `billing/orden.py`, PACTO_SIN_TOPE).
import { Box } from "@mui/material";

export const JORNADAS_PACTO_SIN_TOPE = 31;

export const sinTopeJornadas = (jornadas) => jornadas == null || Number(jornadas) >= JORNADAS_PACTO_SIN_TOPE;

// Hay excepción cuando el plan base trae un número y a la cuenta le aplica otro.
export const hayExcepcionJornadas = (jornadas, jornadasPlan) =>
  jornadas != null && jornadasPlan != null && Number(jornadas) !== Number(jornadasPlan);

const JornadasAlMes = ({ jornadas, jornadasPlan, corto = false }) => {
  const sin = sinTopeJornadas(jornadas);
  const cifra = sin ? (corto ? "Sin tope" : "jornadas sin tope") : String(jornadas);
  const resto = sin ? "" : corto ? " al mes" : " jornadas al mes";
  if (!hayExcepcionJornadas(jornadas, jornadasPlan)) return <>{cifra}{resto}</>;
  return (
    <>
      <Box component="s" data-testid="jornadas-plan-tachado" sx={{ textDecoration: "line-through", color: "var(--text-muted)", fontWeight: 400 }}>
        {jornadasPlan}
      </Box>
      {" → "}
      <Box component="b" data-testid="jornadas-acordadas" sx={{ fontWeight: 700 }}>
        {cifra}
      </Box>
      {resto} · acordado contigo
    </>
  );
};

export default JornadasAlMes;
